// extracted by mini-css-extract-plugin
module.exports = {"detail":"sewage-detail_detail_L2tyH","listWrap":"sewage-detail_listWrap_3oqGC"};